import React from 'react';
import useStepper from '../../common/hooks/useStepper';

interface StepperProps {
  children: (props: StepperState) => React.ReactNode;
  totalSteps: number;
}

interface StepperState {
  currentStep: number;
  goNext: () => void;
  goBack: () => void;
  restart: () => void;
}

const Stepper = ({ children, totalSteps }: StepperProps) => {
  const { currentStep, goNext, goBack, restart } = useStepper(totalSteps);

  return <>{children({ currentStep, goNext, goBack, restart })}</>;
};

export default Stepper;
